// extracted by mini-css-extract-plugin
module.exports = {"SpecIcon":"SpecIcon_pZzAY","InstanceCardCentered":"InstanceCardCentered_p6beg"};